import { Component, OnInit, Input } from '@angular/core';
import { PopoverController} from '@ionic/angular'
import { TeacherProvider } from 'src/app/providers/teacher/teacher.provider';
import { ParentEducationMoment } from 'src/app/models/parent-education-moment';
import { ResourcesProvider } from 'src/app/providers/resources/resources.provider';
import { Resources } from 'src/app/models/resources';
import { TeacherStore } from 'src/app/stores/teacher.store';
import { ResourceStore } from 'src/app/stores/resources.store';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-add-pem-slideout',
  templateUrl: './add-pem-slideout.component.html',
  styleUrls: ['./add-pem-slideout.component.scss']
})
export class AddPemSlideoutComponent implements OnInit {

  _addPemHandler: (pem: ParentEducationMoment) => void = (() => {})

  @Input() set addPemHandler(handler: (pem: ParentEducationMoment) => void) {
    this._addPemHandler = handler
    this.resetState()  // every time we bring up the component, go to main screen (TODO: can we hook into lifecycle for this??)
  }

  @Input() pemName: string = 'PEM';

  get addPemHandler(): (pem: ParentEducationMoment) => void { return this._addPemHandler }

  mtLibrarySelected = true


  resources: Resources = Resources.defaults(); // this.resourcesProvider.resources
  ngUnsubscribeResources = new Subject();

  searchText: string = ''
  filtersVisible: boolean = false
  toggleFiltersText: string = ''
  detailsVisible: boolean = false

  filter = {
    sections: [
      { name: 'Participation', items: [
        { name: 'Parent/caregiver as musical model', selected: false },
        { name: 'Setting expectations', selected: false },
        { name: 'Making music at home', selected: false }
      ]},
      { name: 'Curriculum/Philosophy', items: [
        { name: 'Rhythm', selected: false },
        { name: 'Tonality', selected: false },
        { name: 'Instruments & Props', selected: false },
        { name: 'Why we do what we do in class', selected: false }
      ]},
      { name: 'Music Development', items: [
        { name: 'Rhythm Development', selected: false },
        { name: 'Tonal Development', selected: false },
        { name: 'Audiation', selected: false },
        { name: 'Primary Instrument', selected: false },
        { name: 'General Music Development', selected: false },
      ]},
      { name: 'Other', items: [
        { name: 'Child & Brain Development', selected: false },
        { name: 'Babies', selected: false },
        { name: 'Generations', selected: false },
        { name: 'Rhythm Kids', selected: false },
        { name: 'Classroom Management', selected: false },
        { name: 'Demo Classes', selected: false },
        { name: 'General Benefits of Music', selected: false },
      ]}
    ]
  }

  constructor(private popoverCtrl: PopoverController,
    private teacherProvider: TeacherProvider,
    // private resourcesProvider: ResourcesProvider,
    private resourceStore: ResourceStore) {
  }

  ngOnInit() {
    this.resetState()

    this.resources = this.resourceStore.getResources();
    this.resourceStore.state$
        .pipe(takeUntil(this.ngUnsubscribeResources))
        .subscribe(() => {
          this.resources = this.resourceStore.getResources();
        });
  }

  ngOnDestroy(){
    this.ngUnsubscribeResources.next(true);
    this.ngUnsubscribeResources.complete();
  }

  resetState() {
    this.mtLibrarySelected = true

    this.filter.sections.forEach(section => (section.items.forEach(item => item.selected = false)))
    this.searchText = ''
    this.filtersVisible = false
    this.toggleFiltersText = 'Show Filters'
    this.detailsVisible = false
    this.customPem = ParentEducationMoment.defaults()
  }

  back() {
    this.detailsVisible = false
  }

  cancel() {
    this.addPemHandler(null)
  }

  addPem() {
    this.addPemHandler(this.detailPem)
  }

  selectMTLibrary() {
    this.mtLibrarySelected = true
  }

  selectCustomPem() {
    this.mtLibrarySelected = false
  }

  // MTLibrary PEM

  anyFilterSelected(): boolean {
    for (const section of this.filter.sections) {
      for (const item of section.items) {
        if (item.selected) {
          return true
        }
      }
    }

    return false
  }

  get pems(): ParentEducationMoment[] {
    let pems = this.resources.parentEducationMoments
    pems = this.searchPems(pems)
    pems = this.filterPems(pems)
    pems = this.sortPems(pems)
    return pems
  }

  private searchPems(pems: ParentEducationMoment[]): ParentEducationMoment[] {
    if (this.searchText.length) {
      const searchText = this.searchText.toLowerCase()
      pems = pems.filter( (pem: ParentEducationMoment) => {
        return pem.name.toLowerCase().indexOf(searchText) >= 0 ||
          (pem.description || '').toLowerCase().indexOf(searchText) >= 0 ||
          (pem.types || '').toLowerCase().indexOf(searchText) >= 0
      })
    }
    return pems
  }

  private filterPems(pems: ParentEducationMoment[]): ParentEducationMoment[] {
    pems = pems.filter((pem: ParentEducationMoment) => {
      if (pem.name.length === 0) { return false }
      return true
    })

    if (this.anyFilterSelected()) {
      pems = pems.filter((pem: ParentEducationMoment) => {
        for (const section of this.filter.sections) {
          for (const item of section.items) {
            if (item.selected && !pem.typesList().includes(item.name)) {
              return false
            }
          }
        }
        return true
      })
    }

    return pems
  }

  private sortPems(pems: ParentEducationMoment[]): ParentEducationMoment[] {
    return pems.sort((a: ParentEducationMoment, b: ParentEducationMoment) => {
      if (a.isWeekOne) { return -1 }
      if (b.isWeekOne) { return 1 }
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
    })
  }

  toggleFilters() {
    this.filtersVisible = !this.filtersVisible
    this.toggleFiltersText = this.filtersVisible ? 'Hide Filters' : 'Show Filters'
  }

  clearFilters() {
    this.filter.sections.forEach(section => (section.items.forEach(item => item.selected = false)))
  }

  toggleFilter(section, item) {
    item.selected = !item.selected
    section.items.forEach(i => i.selected = (i === item) ? item.selected : false)
  }

  addSelectedPem(pem: ParentEducationMoment) {
    this.addPemHandler(pem)
  }

  detailPem: ParentEducationMoment

  showDetails(pem: ParentEducationMoment) {
    this.detailPem = pem
    this.detailsVisible = true
  }

  // Custom PEM

  customPem: ParentEducationMoment = ParentEducationMoment.defaults()

  addCustomPem() {
    if (this.customPem.name.length > 0) {
      let now = Math.round((new Date()).getTime() / 1000);
      now *= 1000000;
      this.customPem.dirtyDate = now;
      this.teacherProvider.addCustomPem(this.customPem)
      this.addPemHandler(this.customPem)
    }
  }

  // TODO: move this into a shared collection of css utilities
  textareaHeight(id: string, minHeight: number): string {
    // I was using AutosizeModule (https://github.com/chrum/ngx-autosize) but it was giving the
    // elements way too much height. Clearly a bug. Decided to roll my own.
    // https://stackoverflow.com/questions/50762433/resizetextarea-in-angular-5
    const textArea = document.getElementById(id)
    if (!textArea) {
      return minHeight + 'px'
    }
    textArea.style.overflow = 'hidden'
    // textArea.style.height = 'auto'   // this is part of the documented solution, but causes the Notes field to jump (Safari)
    textArea.style.height = Math.max(minHeight, textArea.scrollHeight) + 'px'
    return textArea.style.height
  }

  trackByPemUuid(index: number, pem: ParentEducationMoment): string {
    return pem.uuid
  }
}
